import type { PrivacyPolicyPage, PrivacyPolicyPageQuery } from '@edwin-group/people-graphql';

import { initializeApolloWithoutToken } from '../lib/apollo-client';
import requestHandler from '../requestHandler';
import { QUERY_PRIVACY_POLICY_PAGE } from '@edwin-group/people-graphql';

export const getPage = async () => {
  const apolloClient = initializeApolloWithoutToken();

  const { data, error } = await requestHandler(
    apolloClient.query<PrivacyPolicyPageQuery>({
      query: QUERY_PRIVACY_POLICY_PAGE,
      fetchPolicy: 'cache-first',
    }),
  );

  return {
    page: data?.privacyPolicyPage?.data?.attributes as PrivacyPolicyPage,
    error,
  };
};
